import React from 'react';
import { Table } from 'antd';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

// import Link from '../../../components/link';
import { LoadingIcon } from '../../../components/loading';

const APIKeyList = withTranslation()((props) => {
  const { t } = props;

  const columns = [{
    title: t('api_key.reference'),
    dataIndex: 'name',
  }, {
    title: t('api_key.expires_at'),
    dataIndex: 'expires_at',
    render: (expires_at) => moment(expires_at).format('lll'),
  }, {
    title: t('api_key.disabled_at'),
    dataIndex: 'disabled_at',
    render: (disabled_at) => ((disabled_at) ? moment(disabled_at).format('lll') : ''),
  },
  /*
  {
    title: '',
    width: 100,
    render: () => (
      <Link to="/edit">{t('disable')}</Link>
    ),
  */
  ];

  return (
    <Table
      dataSource={props.keys || []}
      columns={columns}
      pagination={false}
      {...props}
      loading={{
        indicator: LoadingIcon,
        size: 'large',
        spinning: props.loading || false,
      }}
      bordered={false}
      rowKey={(r, i) => i}
      scroll={{ x: true }}
    />
  );
});

export default APIKeyList;
